export default __webpack_public_path__ + "static/media/sideBar-bg.ffbd76c4.webp";